<page-content>
    <header-elitment header
            [hasSideMenu]="true">
    </header-elitment>
    <side-menu left-menu>
        <libraries-side-menu></libraries-side-menu>
    </side-menu>
    <error-401 *ngIf="is401"></error-401>
    <error-404 *ngIf="is404"></error-404>
    <module-content *ngIf="!is401 && !is404"
                    [title]="pageTitle"
                    [mainActions]="mainActions">
        <div *ngIf="dataSource.count === 0" class="legend">{{ 'message.no_annual_plan_yet' | translate }}</div>
        <div class="search-bar">
          <mat-form-field [class.hidden]="dataSource.count == 0"
                        color="primary"
                        >
            <input matInput
                   type="text"
                   maxlength="255"
                   placeholder="{{ 'Filter' | translate }}"
                   #filter
                   (keyup)="onFilterKeyup(filter.value)">
            <mat-icon matSuffix>search</mat-icon>
          </mat-form-field>
        </div>
        <mat-table *ngIf="dataSource.count > 0"
                   [dataSource]="dataSource"
                   matSort
                   (matSortChange)="onSortChange($event)">
            <mat-header-row *matHeaderRowDef="columns"></mat-header-row>
            <mat-row *matRowDef="let row; columns: columns"></mat-row>

            <ng-container matColumnDef="title">
                <mat-header-cell *matHeaderCellDef mat-sort-header class="name-cell">{{ 'Title' | translate }}</mat-header-cell>
                <mat-cell *matCellDef="let row; let i = index" class="name-cell">
                    <div *ngIf="row.rights.view; else notLink">
                        <a (click)="onRowClicked(row)">{{ row.title }}</a>
                    </div>
                    <ng-template #notLink>
                        <div>{{ row.title }}</div>
                    </ng-template>
                </mat-cell>
            </ng-container>

            <!--
            <ng-container matColumnDef="startedAt">
                <mat-header-cell *matHeaderCellDef class="name-cell">{{ 'StartedAt' | translate }}</mat-header-cell>
                <mat-cell *matCellDef="let row; let i = index" class="name-cell">
                    <div>{{ row.startedAt|appDate:'mediumDate' }}</div>
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="endedAt">
                <mat-header-cell *matHeaderCellDef class="name-cell">{{ 'EndedAt' | translate }}</mat-header-cell>
                <mat-cell *matCellDef="let row; let i = index" class="name-cell">
                    <div>{{ row.endedAt|appDate:'mediumDate' }}</div>
                </mat-cell>
            </ng-container>
            -->

            <ng-container matColumnDef="creator">
                <mat-header-cell *matHeaderCellDef mat-sort-header class="name-cell">{{ 'Created_by' | translate }}</mat-header-cell>
                <mat-cell *matCellDef="let row; let i = index" class="name-cell">
                    <div>{{ row.creator?.firstName + ' ' + row.creator?.lastName }}</div>
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="action">
                <mat-header-cell  mat-header-cell *matHeaderCellDef class="cell-right"></mat-header-cell>
                <mat-cell mat-cell *matCellDef="let row;  let i = index" class="cell-right">
                    <button *ngIf="row.rights.assign || row.rights.duplicate || row.rights.edit || row.rights.delete"
                            mat-icon-button
                            [matMenuTriggerFor]="menu">
                        <mat-icon>more_vert</mat-icon>
                    </button>
                    <mat-menu #menu="matMenu" xPosition="before">

                        <button mat-menu-item (click)="onAssignToClicked(row)" *ngIf="row.rights.assign">
                            <mat-icon>assignment_ind</mat-icon>&nbsp;
                            <span>{{ 'AssignTo' | translate }}</span>...
                        </button>

                        <button mat-menu-item (click)="onDuplicateClicked(row)" *ngIf="row.rights.duplicate">
                            <mat-icon>filter_none</mat-icon>&nbsp;
                            <span>{{ 'Duplicate' | translate }}</span>
                        </button>

                        <button mat-menu-item (click)="onEditClicked(row)" *ngIf="row.rights.edit">
                            <mat-icon>edit_outlined</mat-icon>&nbsp;
                            <span>{{ 'Edit' | translate }}</span>
                        </button>

                        <button mat-menu-item (click)="onDeleteClicked(row)" *ngIf="row.rights.delete">
                            <mat-icon>delete</mat-icon>
                            <span>{{ 'Delete' | translate }}</span>
                        </button>
                    </mat-menu>
                </mat-cell>
            </ng-container>
        </mat-table>
        <mat-paginator [class.hidden]="dataSource.count == 0"
                       [pageSizeOptions]="[10]"
                       hidePageSize
                       showFirstLastButtons>
        </mat-paginator>
    </module-content>
</page-content>
